"use client";

import { useEffect } from "react";

const HTML_CLASS = "bg-app-header";

/**
 * Applies the tenant app-header background colour to the <html> element while
 * an authentication route is mounted, then removes it on unmount. iOS Safari
 * paints the overscroll / collapsing-toolbar area with the root element's
 * background, so covering <html> here avoids the white strip that would
 * otherwise show below the dark auth layout.
 */
function AuthDocumentBackground() {
	useEffect(() => {
		const { documentElement } = document;
		documentElement.classList.add(HTML_CLASS);

		return () => {
			documentElement.classList.remove(HTML_CLASS);
		};
	}, []);

	return null;
}

export default AuthDocumentBackground;
